module.exports = __webpack_public_path__ + "static/media/computer_usd_v2.ca2f6d6e.svg";